export default __webpack_public_path__ + "static/media/bell.d1944ad7.svg";